@if (ready) {
  <div [ngStyle]="styles" class="{{ originNamespace }}-namespace main-app">
    <!-- chrome extension -->
    @if (runningAsChromeExtension) {
      <section id="chrome-extension">
        <!-- TODO: Merge the two headers as they're very similar -->
        @if (frameCollapsed) {
          <header class="frame collapsed" (click)="toggleExtension()">
            <a
              href="https://www.KyloePartners.com"
              target="_blank"
              class="kyloe-logo-mask"
              [matTooltip]="'Visit our website'"
              matTooltipShowDelay="500"
              matTooltipClass="small-tooltip"
              matTooltipPosition="right"
            ></a>
            <ul>
              <li>
                <i
                  class="bhi-sort-desc"
                  [matTooltip]="'Expand'"
                  matTooltipShowDelay="500"
                  matTooltipClass="small-tooltip"
                  matTooltipPosition="left"
                  (click)="toggleExtension()"
                ></i>
              </li>
              <li>
                <i
                  class="bhi-close-o"
                  [matTooltip]="'Close - This will lose any current changes'"
                  matTooltipShowDelay="500"
                  matTooltipClass="small-tooltip"
                  matTooltipPosition="left"
                  (click)="closeExtension()"
                ></i>
              </li>
            </ul>
          </header>
        }
        @if (!frameCollapsed) {
          <header class="frame">
            <a
              href="https://www.KyloePartners.com"
              target="_blank"
              class="kyloe-logo-mask"
              [matTooltip]="'Visit our website'"
              matTooltipShowDelay="500"
            ></a>
            @if (showSpinner) {
              <div
                class="chrome-extension-loading-spinner spinner-border spinner-border-sm"
                [matTooltip]="'Loading data'"
                matTooltipShowDelay="500"
              ></div>
            }
            <ul>
              <li>
                <i class="bhi-sort-asc" [matTooltip]="'Collapse'" matTooltipShowDelay="500" (click)="toggleExtension()"></i>
              </li>
              <li>
                <i
                  class="bhi-close-o"
                  [matTooltip]="'Close - This will lose any current changes'"
                  matTooltipShowDelay="500"
                  (click)="closeExtension()"
                ></i>
              </li>
            </ul>
          </header>
        }
        <main id="components" [ngStyle]="{ display: frameCollapsed ? 'none' : 'block' }" class="scrollable-container">
          <app-alert-banner #alertbanner></app-alert-banner>
          <section
            id="{{ renderMode }}"
            class="content files-section"
            [ngClass]="filesListOpen ? 'file-section-open' : 'file-section-closed'"
            [ngStyle]="{ display: frameCollapsed ? 'none' : 'block' }"
          >
            <app-file-list-view
              [config]="mergeComponentConfig.fileListViewConfig"
              [filesListOpen]="filesListOpen"
              (emitFilesListOpen)="onFilesListExpand($event)"
            ></app-file-list-view>
            @if (!runningAsChromeExtension) {
              <app-entity-preview></app-entity-preview>
            }
            <app-merge-basket-view
              [config]="mergeComponentConfig.mergeBasketViewConfig"
              [filesListOpen]="filesListOpen"
            ></app-merge-basket-view>
          </section>
          <!--------------------------->
          <app-template-list-view
            [templatesListOpen]="templatesListOpen"
            (emitTemplatesListOpen)="onTemplatesListExpand($event)"
          ></app-template-list-view>
        </main>
      </section>
    }
    <!-- web-app -->
    @if (!runningAsChromeExtension) {
      <!--    TODO: This alert banner might need repositioning for webapp?-->
      <app-alert-banner #alertbanner></app-alert-banner>
      <!-- merge components bits -->
      @if (!runningAsChromeExtension) {
        <app-header [showEntityPicker]="!runningAsChromeExtension" appName="AwesomeDocs" complyTitle="Kyloe Comply">
          @if (originNamespace === 'bullhorn' && senderPickerFeatureEnabled()) {
            <app-document-sender-picker userPicker></app-document-sender-picker>
          }
        </app-header>
      }
      <section id="{{ renderMode }}" class="content">
        <section id="left-panel">
          <app-file-list-view [config]="mergeComponentConfig.fileListViewConfig"></app-file-list-view>
          <!-- TODO: Hide from within the template -->
          <app-template-list-view></app-template-list-view>
          @if (!runningAsChromeExtension) {
            <app-recent-activity></app-recent-activity>
          }
        </section>
        <section id="right-panel" class="scrollable-container">
          @if (!runningAsChromeExtension) {
            <app-entity-preview [namespace]="originNamespace"></app-entity-preview>
          }
          <app-merge-basket-view [config]="mergeComponentConfig.mergeBasketViewConfig"></app-merge-basket-view>
          @if (!runningAsChromeExtension) {
            <app-recent-activity [sidebar]="true"></app-recent-activity>
          }
        </section>
      </section>
      <!--------------------------->
    }
  </div>
}
@if (!ready) {
  <div class="{{ renderMode }}">
    @if (runningAsChromeExtension) {
      <header [ngClass]="frameCollapsed ? 'frame collapsed' : 'frame'">
        <a
          href="https://www.KyloePartners.com"
          target="_blank"
          class="kyloe-logo-mask"
          [matTooltip]="'Visit our website'"
          matTooltipShowDelay="500"
        ></a>
        <ul>
          <li>
            <i
              [ngClass]="frameCollapsed ? 'bhi-sort-desc' : 'bhi-sort-asc'"
              class="bhi-sort-asc"
              [matTooltip]="frameCollapsed ? 'Expand' : 'Collapse'"
              matTooltipShowDelay="500"
              (click)="toggleExtension()"
            ></i>
          </li>
          <li>
            <i class="bhi-close-o" [matTooltip]="'Close'" matTooltipShowDelay="500" (click)="closeExtension()"></i>
          </li>
        </ul>
      </header>
    }
    <div class="load-container">
      <div class="container">
        <mat-icon [ngClass]="load.icon">
          @if (load.icon !== 'app-loading') {
            {{ load.icon }}
          }
        </mat-icon>
        <div>{{ load.text }}</div>
        @if (popupReminder) {
          <div class="popup-reminder">
            {{ popupReminder }}
          </div>
        }
      </div>
    </div>
  </div>
}
<span
  id="version-number"
  [ngClass]="{ 'expand-version': expandVersion }"
  [matTooltip]="'Double click to copy - ' + version"
  matTooltipShowDelay="500"
  (dblclick)="copyToClipboard(version)"
  >{{ version }}</span
>
